"use client";

import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

import { identifyProductAnalyticsUser } from "@/lib/analytics/product-events";
import { useStore } from "@/stores/appStore";

export function PostHogIdentity() {
  const postHog = usePostHog();
  const userId = useStore((state) => state.user?.userId ?? null);

  useEffect(() => {
    identifyProductAnalyticsUser(userId, postHog);
  }, [postHog, userId]);

  return null;
}
